<template>
  <div class="bg">
    <div class="cont">
      <div class="c1"><img src="../assets/image/404/01.png" class="img1" /></div>
      <h2>哎呀…您访问的页面不存在</h2>
      <div class="c2"><a href="javascript:void(0)" @click="back()" class="re">返回</a><a href="https://54traveler.com/" class="home">网站首页</div>
      <div class="c3"><a href="https://54traveler.com/" class="c3">稻草人</a>提醒，您可能输入了错误的网址，或者该网页已被管理员删除或移动</div>
    </div>
  </div>
</template>

<style scoped>
  img{border:none}
  a *{cursor:pointer}
  ul,li{list-style:none}
  table{table-layout:fixed;}
  table tr td{word-break:break-all; word-wrap:break-word;}

  a{text-decoration:none;outline:none}
  a:hover{text-decoration:underline}
  .cf:after{content: ".";display: block;height: 0;font-size: 0;clear:both;visibility: hidden;}
  .cf{zoom: 1;clear:both}

  .bg{width:100%;background:url("../assets/image/404/01.jpg") no-repeat center top #DAD9D7;position:static;top:0;left:0;height:600px;overflow:hidden}
  .cont{margin:0 auto;width:500px;line-height:20px;}
  .c1{height:360px;text-align:center}
  .c1 .img1{margin-top:180px}
  .c1 .img2{margin-top:165px}
  .cont h2{text-align:center;color:#555;font-size:18px;font-weight:normal;height:35px}
  .c2{height:35px;text-align:center}
  .c2 a{display:inline-block;margin:0 4px;font-size:14px;height:24px;color:#626262;padding-top:1px;text-decoration:none;text-align:left}
  .c2 a:hover{color:#626262;text-decoration:none;}
  .c2 a.home{width:96px;background:url("../assets/image/404/02.png");padding-left:30px; background-repeat: no-repeat;}
  .c2 a.home:hover{background:url("../assets/image/404/02.png") 0 -24px}
  .c2 a.home:active{background:url("../assets/image/404/02.png") 0 -48px}
  .c2 a.re{width:96px;background:url("../assets/image/404/03.png");padding-left:30px; background-repeat: no-repeat;}
  .c2 a.re:hover{background:url("../assets/image/404/03.png") 0 -24px}
  .c2 a.re:active{background:url("../assets/image/404/03.png") 0 -48px}
  .c2 a.sr{width:153px;background:url("../assets/image/404/04.png");padding-left:28px}
  .c2 a.sr:hover{background:url("../assets/image/404/04.png") 0 -24px}
  .c2 a.sr:active{background:url("../assets/image/404/04.png") 0 -48px}
  .c3{height:180px;text-align:center;color:#999;font-size:12px}
  #bf{position:absolute;top:269px;left:0;width:100%}
  .bf1{margin:0 auto;width:99px;padding-left:32px}
  .bd{height:600px;overflow:hidden}
  #box{position:absolute;top:165px;left:0;width:100%;text-align:center}
  .bf1{margin:0 auto;width:99px;padding-left:32px}
</style>

<script>
  export default {
    methods: {
      back () {
        window.history.back()
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** 404.vue?3a282a24
 **/